import { createContext, type ReactNode, useContext } from "react";
import type { MemberAttribute } from "../../../shared/types/member.types";
import type { MemberAttributeFilterConfig } from "../components/MemberAttributeFilters/types";

export interface MemberAttributeContextValue {
	memberAttribute: MemberAttribute;
	config: MemberAttributeFilterConfig;
}

const MemberAttributeContext = createContext<
	MemberAttributeContextValue | undefined
>(undefined);

export const useMemberAttributeContext = (): MemberAttributeContextValue => {
	const context = useContext(MemberAttributeContext);
	if (!context) {
		throw new Error("useAudience must be used within MemberAttributeProvider");
	}
	return context as MemberAttributeContextValue;
};

export interface MemberAttributeProviderProps {
	children: ReactNode;
	memberAttribute: MemberAttribute;
	config: MemberAttributeFilterConfig;
}

export const MemberAttributeProvider = ({
	children,
	memberAttribute,
	config,
}: MemberAttributeProviderProps) => {
	const value: MemberAttributeContextValue = {
		memberAttribute,
		config,
	};

	return (
		<MemberAttributeContext.Provider value={value}>
			{children}
		</MemberAttributeContext.Provider>
	);
};
